import { usePageTracking } from '@/hooks/usePageTracking';

/**
 * Provider component that enables page view tracking.
 * Must be placed inside BrowserRouter.
 */
export const PageTrackingProvider = ({ children }: { children: React.ReactNode }) => {
  usePageTracking();
  return <>{children}</>;
};
